<template>
  <section id="rooms">
    <p>Dra och släpp för att ändra ordning.</p>
    <div class="rooms">
        <draggable v-model="rooms" @end="saveSlots" draggable=".draggable-room" animation="200">
            <div class="room draggable-room" v-for="room in rooms" :key="room.id">
                <div class="room-data">
                    <span class="dev"><strong>ID{{ room.id }}:</strong> Slot {{ room.slot }}</span>
                    <span v-if="!room.editing" class="room-data__name">{{ room.name }}</span>
                    <input class="room-data__name" v-if="room.editing" v-model="room.name" :ref="'name-'+room.id" placeholder="Rumsnamn">
                    <span class="dev room-data__status">{{ room.status }}</span>
                    <div class="room-controls">
                      <button class="control edit" v-if="room.editing == false" @click="editRoom(room)">Ändra namn</button>
                      <button class="control save" v-if="room.editing === true" @click="editRoom(room)">Spara</button>
                      <button class="control delete" v-if="room.editing == false" @click="deleteRoom(room)">Ta bort</button>
                    </div>
                </div>
            </div>
            <div @click="addRoom()" class="room add-room">
              <span class="icon"></span>
              <button v-if="creatingroom === false" class="control add">Lägg till rum</button>
              <p v-if="creatingroom === true">Lägger till ett rum...</p>
            </div>
        </draggable>
    </div>
  </section>
</template>

<script>
import draggable from 'vuedraggable'
import axios from 'axios'

export default {
  name: 'Rooms',
  components: {
    draggable
  },
  props: {},
  data: function(){
    return {
      rooms: [],
      creatingroom: false,
      api_url: this.$parent.api_url
    }
  },
  mounted: function(){
    let self = this;

    if( self.$parent.user.token !== '' ){
      self.loadRooms();
    }
    
    this.$root.$on('loadRooms', function(){
      self.loadRooms();
    });
  },
  methods: {
    addRoom(){
      this.creatingroom = true;

      let self = this;
      let url = self.api_url + "/rooms";
      axios
        .post(
          url,
          {
            status: 1,
            slot: self.rooms.length + 1,
            name: 'Nytt rum'
          },
          {
            headers: {
              "Accept": "application/json",
              "Content-Type": "application/json",
              "Authorization": "Bearer " + self.$parent.user.token
            }
          }
        )
        .then(function(response) {
          console.log(response);
          self.loadRooms();
        })
        .catch(function(error) {
          console.log(error);
          console.log("Something went wrong while creating a new room");
        });
      
    },
    deleteRoom(room) {
      console.log("Room ID: ", room);

      if( confirm('Vill du ta bort '+ room.name +'? \nAlla noteringar som hör till rummet kommer också att tas bort.' ) ){
        let self = this;
        let url = self.api_url + "/rooms/" + room.id;
        axios
          .delete(
            url,
            {
              headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": "Bearer " + self.$parent.user.token
              }
            }
          )
          .then(function(response) {
            console.log(response);
            // self.clients = response.data;
            self.loadRooms();
          })
          .catch(function(error) {
            console.log(error);
            console.log("Something went wrong while deleting the room");
          });
      }
    },
    editRoom(room) {
      console.log('Edit room called...');
      if (room.editing === false) {
        room.editing = true;
        this.$forceUpdate();
        this.$nextTick(function() {
          this.$refs["name-" + room.id][0].focus();
        });
      } else {
        room.editing = false;
        this.$forceUpdate();
        this.saveSlots();
      }
    },
    loadRooms() {
      let self = this;
      axios
        .get(self.api_url + "/rooms", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + self.$parent.user.token
          }
        })
        .then(function(response) {
          console.log(response);
          self.rooms = response.data;

          self.rooms.forEach(function(room) {
            room.editing = false;
          });
          self.creatingroom = false;
        })
        .catch(function(error) {
          console.log(error);
          console.log("Something went wrong while loading rooms");
        });
    },
    saveSlots() {
      let self = this;
      axios
        .put(
          self.api_url + "/rooms",
          {
            rooms: self.rooms
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + self.$parent.user.token
            }
          }
        )
        .then(function(response) {
          console.log(response);
        })
        .catch(function(error) {
          console.log(error);
          console.log("Something went wrong while logging in");
        });
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/css/_variables.scss";
  @import "../assets/css/_mixins.scss";
  @import '../assets/css/rooms.scss';
</style>